export default __webpack_public_path__ + "static/media/techblog.d07ecce6.png";